var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 23,
  viewBox: "0 0 22 23",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22 11.805C22 5.692 17.075.738 11 .738S0 5.692 0 11.805c0 5.524 4.023 10.102 9.281 10.933v-7.734H6.488v-3.2h2.793V9.367c0-2.773 1.642-4.305 4.155-4.305 1.204 0 2.462.216 2.462.216V8h-1.387c-1.366 0-1.792.853-1.792 1.729v2.076h3.05l-.487 3.199h-2.563v7.734c5.258-.83 9.281-5.41 9.281-10.933",
  fill: "#1977F2",
  fillRule: "evenodd"
})));
export default SvgIconFacebook;